export const CommonUtils = {
  formatNumber: (number: number) => {
    return number.toLocaleString().split(',').join(' ')
  },
}
